module.exports = __webpack_public_path__ + "static/media/TubeCreation.096b842b.webp";